module.exports = {
  eventCategory: 'Editor UI | Tool Menu | text',

  show: { eventAction: 'show' }
};
